module.exports = __webpack_public_path__ + "img/img-19.20bf6c79.png";